<template>
  <div>
    <button
      :id="`${expandableId}-header`"
      :aria-expanded="expanded.toString()"
      :aria-controls="`${expandableId}-panel`"
      data-test="accordion-button"
      class="accordion-button flex items-center w-full focus:outline-none py-2 px-4 md:py-4"
      @click="toggle(!expanded)"
      @keyup.space="toggle(!expanded)"
    >
      <div class="flex-1 flex items-center">
        <slot name="expandable-title" />
      </div>
      <BaseIcon
        icon="chevron-down"
        class="mr-2 toggle-icon"
        aria-hidden="true"
        :class="{ 'rotated': expanded }"
      />
    </button>
    <div
      v-show="expanded"
      :id="`${expandableId}-panel`"
      :aria-labelledby="`${expandableId}-header`"
      :aria-hidden="expanded ? 'false' : 'true'"
      role="region"
      data-test="accordion-div"
    >
      <slot
        name="expandable-content"
        v-bind="{ expanded }"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
    expandableId: {
      type: [String, Number],
      default: Math.random().toString(36),
    },
  },
  methods: {
    toggle(expanded) {
      this.$emit('toggle', expanded)
    },
  },
}
</script>

<style lang="css" scoped>
.rotated {
  transform: rotateX(180deg);
}

.toggle-icon {
  color: #820000;
  border: 0.1rem solid #820000;
  width: 1.1rem;
  height: 1.1rem;
  padding: 2px;
  border-radius: 100%;
}
</style>
